/* TGGCore: scroll affordance for the mobile-drawer occasions circles.
   A thin gold track under the row shows the scroll position while swiping,
   and the row's right-edge fade retires at the end of the row (is-end).
   The track only appears when the row actually overflows. Contract:
   [data-tgg-occ-row] is the scroll container, [data-tgg-occ-track] > span is
   the thumb. Loaded defer by sections/header.liquid when the drawer tiles
   are enabled; click handling is document-delegated so it survives section
   reloads and pjax. */
(function () {
  function paint(row, thumb) {
    var overflow = row.scrollWidth - row.clientWidth;
    if (overflow <= 0 || !thumb) return;
    var width = Math.max(18, (row.clientWidth / row.scrollWidth) * 100);
    var frac = Math.min(1, Math.max(0, row.scrollLeft / overflow));
    thumb.style.width = width + '%';
    thumb.style.marginLeft = frac * (100 - width) + '%';
    var wrap = row.closest('.tgg-occ-circles');
    if (wrap) wrap.classList.toggle('is-end', overflow - row.scrollLeft < 8);
  }

  /* (Re)binds lazily on every drawer open — a re-rendered drawer loses the
     data flag, so the fresh row gets a fresh scroll listener. */
  function setup() {
    var row = document.querySelector('[data-tgg-occ-row]');
    if (!row) return;
    var track = document.querySelector('[data-tgg-occ-track]');
    var thumb = track && track.querySelector('span');
    if (!track) return;
    if (row.scrollWidth - row.clientWidth < 8) {
      track.hidden = true;
      return;
    }
    track.hidden = false;
    if (!row.dataset.tggOccBound) {
      row.dataset.tggOccBound = '1';
      row.addEventListener('scroll', function () { paint(row, thumb); }, { passive: true });
    }
    paint(row, thumb);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-mobile-menu-trigger]');
    if (!trigger) return;
    /* let the drawer's open transition start before measuring */
    window.setTimeout(function () {
      var details = trigger.closest('details');
      if (details && !details.open) return;
      setup();
    }, 380);
  });
})();
